<template>
  <div>
    <b-card
      no-body
      class="mb-0"
    > 
      <validation-observer ref="simpleRules">
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <h3>Affichage du client : {{ client.idclient }}</h3>
          </b-col>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-end mb-1 mb-md-0"
          >
            <router-link
              :to="{name: 'listclient'}"
              class="btn btn-primary"
              style="margin-bottom: 20px;"
            >
              Retour
            </router-link>
          </b-col>
        </b-row>

        <div class="m-2">
          <b-row>
            <b-col
              cols="12"
              md="6"
              class="align-items-left justify-content-start mb-2 mb-md-0"
            >
              <b-card-text><strong>Référence :</strong> {{ client.idclient }} </b-card-text>
              <b-card-text><strong>Nom :</strong> {{ client.nom  }} </b-card-text>
              <validation-provider #default="{ errors }" name=" " rules="email" >
                <b-form-group label-cols="3" label="Email : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="client.email"
                    type="email"
                    class="editableField" :state="errors.length > 0 ? false:null" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
              </validation-provider>
              <validation-provider #default="{ errors }" name=" " :rules="{ regex:/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/ }" >
                <b-form-group label-cols="3" label="Téléphone : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="client.telephone"
                    type="tel"
                    class="editableField" :state="errors.length > 0 ? false:null" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
              </validation-provider>
              <validation-provider #default="{ errors }" name=" " :rules="{ regex:/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/ }" >
                <b-form-group label-cols="3" label="Mobile : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="client.mobile"
                    type="tel"
                    class="editableField" :state="errors.length > 0 ? false:null" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
              </validation-provider>
            </b-col>
          </b-row>
          <b-row>  
            <div v-for="item in client.adresses" style="width: 50%;">

              <div 
                v-if="item.type == 'FACT' && item.defaut == 'true'" 
                style="padding: 15px; margin-bottom: 15px; background-color: #fff; border-radius: 0.357rem;"
              >
                <h4>Adresse de facturation</h4>
                <b-form-group label-cols="3" label="Adresse 1 : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.adresse1"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Adresse 2 : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.adresse2"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Adresse 3 : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.adresse3"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>                  
                <b-form-group label-cols="3" label="Code postal: " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.codepostal"
                    type="number"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Ville : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.ville"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Département : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.departement"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Pays : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.pays"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
              </div>

              <div 
                v-if="item.type == 'LIVR' && item.defaut == 'true'"
                style="padding: 15px; margin-bottom: 15px; background-color: #fff; border-radius: 0.357rem;" 
              >
                <h4>Adresse de livraison</h4>
                <b-form-group label-cols="3" label="Adresse 1 : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.adresse1"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Adresse 2 : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.adresse2"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Adresse 3 : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.adresse3"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>                  
                <b-form-group label-cols="3" label="Code postal: " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.codepostal"
                    type="number"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Ville : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.ville"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Département : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.departement"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
                <b-form-group label-cols="3" label="Pays : " label-for="input-default" class="editableFieldLabel mb-0">
                  <b-form-input                       
                    v-model="item.pays"
                    type="text"
                    class="editableField" readonly onfocusout="this.readOnly='true';"
                  />
                </b-form-group>
              </div>

            </div>
          </b-row>
        </div>


        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="12"
            class="d-flex align-items-center justify-content-start mb-2 mt-4"
          >
            <h3>Contacts</h3>
          </b-col>

          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >

            <label>Afficher</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="pageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50"
            />
            <label>entrées</label>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="filter"
                class="d-inline-block mr-1"
                placeholder="Recherche..."
              />
              <!-- <b-button
                id="popover-reactive-1"
                variant="primary"
                class="btn-icon"
                >
                <feather-icon icon="PlusIcon" />
              </b-button> -->
            </div>
          </b-col>
        </b-row>
        <!-- Tableau -->
        <b-row>
          <b-col>
            <b-table
              id="datatables"
              ref="tableContacts"
              class="mt-4 mb-4"
              :items="contacts"
              :fields="fields"
              stacked="md"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              :filter="filter"
              :filter-included-fields="filterOn"
              striped
              small
              @filtered="onFiltered"
            >
              <template v-slot:cell()="{ item, field: { key, type, rules } }">
                <validation-provider
                  #default="{ errors }"
                  name=" "
                  :rules="rules"
                >
                  <b-form-input 
                    class="editableField" 
                    v-model="item[key]"
                    :state="errors.length > 0 ? false:null" 
                    readonly 
                    :type="type"
                    ondblclick="this.readOnly='';"
                    onfocusout="this.readOnly='true';"
                  />
                  <!-- <small class="text-danger">{{ errors[0] }}</small> -->
                </validation-provider>
              </template>
              <!-- Column: Actions -->
              <template #cell(actions)="data">
                <b-button
                  v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                  @click="deleteContact(data.item.key)"
                  variant="danger"
                  class="btn-icon rounded-circle"
                >
                  <feather-icon icon="TrashIcon" />
                </b-button>

              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          />
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="primary"
              class="mt-0"
              @click="updateClient"
            >
              Mettre à jour
            </b-button>
          </b-col>
        </b-row>
      </div>
      </validation-observer>
      <!-- POPOVER ADD CONTACT -->
      <b-popover
          id="popover-reactive-1"
          ref="popover"
          target="popover-reactive-1"
          triggers="click"
          :show.sync="popoverShow"
          placement="auto"
          container="my-container"
      >
          <template #title>
            <div class="d-flex justify-content-between align-items-center">
              <span>Ajouter un contact</span>
            </div>
          </template>
          <validation-observer ref="simpleRules">
          <div>
            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Nom"
                rules="required"
              >
                <b-form-input
                  v-model="datasContact.nom"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Nom"
                  required
                  size="sm"
                  class="mt-0"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Prénom"
                rules="required"
              >
                <b-form-input
                  v-model="datasContact.prenom"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Prénom"
                  size="sm"
                  class="mt-0"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="email"
              >
                <b-form-input
                  v-model="datasContact.email"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Email"
                  type="email"
                  size="sm"
                  class="mt-0"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Téléphone"
                :rules="{ regex:/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/ }"
              >
                <b-form-input
                  v-model="datasContact.telephone"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Téléphone"
                  type="tel"
                  size="sm"
                  class="mt-0"
                />
              <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <validation-provider
                #default="{ errors }"
                name="Mobile"
                :rules="{ regex:/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/ }"
              >
                <b-form-input
                  v-model="datasContact.portable"
                  :state="errors.length > 0 ? false:null"
                  placeholder="Mobile"
                  type="tel"
                  size="sm"
                  class="mt-0"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <!-- button -->
            
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="primary"
              class="mt-0"
              @click="submitFormContact"
            >
              Ajouter
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              size="sm"
              variant="danger"
              class="mt-0"
              @click="onClose"
            >
              Annuler
            </b-button>  
          </div>
          </validation-observer>
      </b-popover>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BButton,
  BTable,
  BTabs,
  BTab,
  BLink,
  BDropdown,
  BDropdownItem,
  BPopover,
  BPagination,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import PouchDB from 'pouchdb'
import moment from 'moment'

import { localize, ValidationProvider, ValidationObserver } from 'vee-validate'
import fr from 'vee-validate/dist/locale/fr.json';
localize('fr', fr);

import { required, email } from '@validations'

export default {
  components: {
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BInputGroup,
    BButton,
    BTable,
    BTabs,
    BTab,
    BLink,
    BDropdown,
    BDropdownItem,
    BPagination,
    BPopover,
    vSelect,
    ValidationProvider,
    ValidationObserver
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      fields: [
        { key: 'nom', label: 'Nom', editable: true, type: 'text', rules: 'required', sortable: true },
        { key: 'prenom', label: 'Prénom', editable: true, type: 'text', rules: 'required', sortable: true },
        { key: 'email', label: 'Email', editable: true, type: 'email', rules: 'email', sortable: true },
        { key: 'telephone', label: 'Téléphone', editable: true, type: 'tel', rules: { regex:/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/ }, sortable: true },
        { key: 'portable', label: 'portable', editable: true, type: 'tel', rules: { regex:/^\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}$/ }, sortable: true },
        { key: 'actions', label: '', sortable: false, thStyle: { width: '60px' } },
      ],
      required,
      email,
      popoverShow: false,
      datasContact: [],
      client: [],
      contacts: [],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      currentPage: 1,
      pageOptions: [5, 10, 25, 50, 100],
      filter: null,
      outlined: true,
      filterOn: ['name', 'email'],
      sortBy: 'name',
      sortDirection: 'asc',
      sortDesc: false,
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database')),
    }
  },
  computed: {
    editableFields() {
      return this.fields.filter(field => field.editable)
    },
    rows() {
      return this.items.length
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  created() {
    this.localDB.get(this.$route.params.id, this.setClients)
  },
  customButtons: {
    default: true,
  },
  methods: {
    onClose() {
      this.popoverShow = false
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    setClients(err, doc) {
      if (err) {
        console.log('err', err)
      }
      console.log('client', doc)
      this.client = doc

      for (let i = 0; i < doc.contacts.length; i++) {
        this.contacts.push({
          key: i,
          nom: doc.contacts[i].nom,
          prenom: doc.contacts[i].prenom,
          email: doc.contacts[i].email,
          telephone: doc.contacts[i].telephone,
          portable: doc.contacts[i].portable
        })
      }
      this.totalRows = this.contacts.length
    },
    submitFormContact() {
      return new Promise((resolve, reject) => {
        this.$refs.simpleRules.validate().then(success => {
          if (success) {
            if(this.client.contacts == null) { this.client.contacts = [] }

            this.client.contacts.push({
              nom: this.datasContact.nom,
              prenom: this.datasContact.prenom,
              email: this.datasContact.email,
              telephone: this.datasContact.telephone,
              portable: this.datasContact.portable
            })
            // update client
            this.pushClient()
            this.datasContact = {}
            this.popoverShow = false
            this.$router.currentRoute

          } else {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Erreur de saisie',
                icon: 'CoffeeIcon',
                variant: 'warning',
                text: 'Merci de renseigner les champs reqis',
              },
            })
            reject()
          }
        })
      })
    },
    deleteContact(key) {
      this.contacts.splice(key,1)
      this.client.contacts.splice(key,1)
    },
    updateClient() {
      console.log('contact', this.contacts)

      this.client.contacts = []
      for (let i = 0; i < this.contacts.length; i++) {
        this.client.contacts.push({
          nom: this.contacts[i].nom,
          prenom: this.contacts[i].prenom,
          email: this.contacts[i].email,
          telephone: this.contacts[i].telephone,
          portable: this.contacts[i].portable
        })
      }
      // update client
      this.pushClient()
      this.$router.currentRoute
    },
    pushClient() {
      // Mise à jour du client
      this.client.datemodif = moment().format('YYYY-MM-DDTHH:mm:ss')
      this.localDB.put(this.client, (err, response) => {
        if (err) {
          console.log('errvalidation', err);
        } else {
          
          this.$toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: 'Contact enregistrée',
              icon: 'CoffeeIcon',
              variant: 'success',
              text: 'Votre contact a été enregistré',
            },
          })

          this.localDB.sync(this.remoteDB)
          .on('complete', complete => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Commande syncronisée',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Vos données ont été syncronisées',
              },
            })
          })
          .on('error', err => {
            this.$toast({
              component: ToastificationContent,
              position: 'top-right',
              props: {
                title: 'Problème de synchronisation',
                icon: 'CoffeeIcon',
                variant: 'success',
                text: 'Impossible de synchronisée la commande',
              },
            })
          })
          this.contacts = []
          this.localDB.get(this.$route.params.id, this.setClients)
        }
      })
    }
  },
}
</script>

<style>
    .btn-primary {
        margin-right: 12px;
    }
    .per-page-selector {
      width: 90px;
    }
    .btNopadding button {
      padding: 0;
    }
    @media (max-width: 767.98px) {
      .table.b-table.b-table-stacked-md > tbody > tr > [data-label]::before {
        text-align: left;
      }
    }
</style>

<style lang="scss">
  @import '~@core/scss/vue/libs/vue-select.scss';
</style>

